/*@flow*/
const matchBadChars = /(\(|\)|[\\]|\[|\])+/gi;

export default (obj: { label: ?string, value: any }, txt: string): boolean => {
  txt = txt || '';
  txt = txt.replace(matchBadChars, ''); // Remove bad characters.
  return Boolean(obj.label && String(obj.label).match(new RegExp(txt, 'gi')));
};
